import { Directive, HostListener, Input } from "@angular/core";
import { ExcelExportService } from "../services/excel-export.service";

@Directive({
    selector: "[appExcelExport]",
    standalone: false
})
export class ExcelExportDirective {
  constructor(private exportService: ExcelExportService) {}

  @Input("appExcelExport") dataToExport: any[];
  @Input() fileName: string;
  @Input() columnNames: any[];

  @HostListener("click") onClick() {
    const columns = this.removeColumns(this.columnNames);
    const rows = this.formatData(this.dataToExport, columns);
    this.exportService.exportToExcel(rows, this.fileName);
  }

  private formatData(jsonData: any[], columns: any[]) {
    let tempObj = {};
    const result = [];
    // copying data to a new data structure dropping columns that do not need to be displayed
    // also renaming the colunm headers to names used in the view display
    for (const element of jsonData) {
      for (const name of columns) {
        tempObj[name.header] = element[String(name)];
      }

      result.push(tempObj);
      tempObj = {};
    }

    return result;
  }

  removeColumns(columns) {
    const result = [];

    for (const column of columns) {
      if (column.header !== "Regions") {
        result.push(column);
      }
    }

    return result;
  }
}
